import { Subject } from "rxjs";

const subject = new Subject();

export const notificationsService = {
  sendNotification: (notification) => subject.next(notification),
  clearNotifications: () => subject.next(),
  getNotification: () => subject.asObservable(),
};
